import React from "react";
import {ButtonLinkStyle} from "../../../../Components/Inputs";
import {convertToCurrencyFormat} from "../../Aph/AphQueue/aphQueueUtility";
import {getLoanDurationTextByValue, getLoanLibraryMediaFormatTextByValue} from "../loanLibraryConstants";
import {GridCell, GridContainer} from "../../../../Components/Grid";
import {convertDateToPrintString} from "../../../../Utilities/Types/dateUtilities";
import {allow} from "../../../../Components/Authorize";
import * as PolicyEvents from "../../../../Components/Authorize/policyEventsConstants";
import {isFimcAdmin} from "../../../../Utilities/LocalStorage/storageUtilities";
import {getAvailabilityStatus, renderCatalogDetail} from "../loanLibraryCatalogUtilities";

interface LoanLibraryCatalogResultsRowProps {
    catalogResource: Record<string, any>;
    canManageCatalog?: boolean;
    handleAddToQueue: (id: string) => void;
    handleEdit: (id: string) => void;
}

export const LoanLibraryCatalogResultsRow = ({
                                                 catalogResource,
                                                 handleAddToQueue,
                                                 handleEdit,
                                             }: LoanLibraryCatalogResultsRowProps) => {

    const handleClickEdit = () => {
        handleEdit(catalogResource.loanLibraryCatalogId);
    };

    const handleClickAddToQueue = () => {
        handleAddToQueue(catalogResource.loanLibraryCatalogId);
    };

    const availabilityStatus = getAvailabilityStatus(
        catalogResource.quantityCurrentlyAvailable,
        catalogResource.totalQuantity
    );

    const isAvailable = (catalogResource.quantityCurrentlyAvailable || 0) > 0;

    const formatDate = (dateValue: string | null | undefined) => {
        if (!dateValue) return null;
        return convertDateToPrintString(new Date(dateValue));
    }

    const canManageCatalog = allow(PolicyEvents.MANAGE_LOAN_LIBRARY_CATALOG);

    return (
        <GridContainer className="catalog__item" hasMarginX id={catalogResource.catalogNumber}
                       data-testid={catalogResource.catalogNumber}>
            <GridCell>
                <h3 id={`title${catalogResource.loanLibraryCatalogId}`} style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: '15px'
                }}>
                    <span>{catalogResource.productName}</span>
                    <span style={{display: 'flex', alignItems: 'center', gap: '15px'}}>
                        <span style={{fontWeight: 'normal'}}>{availabilityStatus}</span>
                        <ButtonLinkStyle
                            label={isAvailable ? "Add to Queue" : "Add to Waitlist"}
                            name={`btnAddQueue${catalogResource.loanLibraryCatalogId}`}
                            onClick={handleClickAddToQueue}
                        />
                    </span>
                </h3>

                {isFimcAdmin() && renderCatalogDetail(catalogResource.accessNumber, "Access Number")}
                {renderCatalogDetail(catalogResource.catalogNumber, "Catalog Number")}
                {renderCatalogDetail(catalogResource.author, "Author")}
                {renderCatalogDetail(getLoanLibraryMediaFormatTextByValue(catalogResource.mediaFormat), "Media Format")}
                {renderCatalogDetail(catalogResource.manufacturer, "Manufacturer")}
                {renderCatalogDetail(formatDate(catalogResource.publicationDate), "Publication Date")}
                {isFimcAdmin() && renderCatalogDetail(formatDate(catalogResource.dateOfPurchase), "Date of Purchase")}
                {renderCatalogDetail(convertToCurrencyFormat(catalogResource.cost), "Cost")}
                {renderCatalogDetail(catalogResource.recommendedQuantity, "Recommended Quantity")}
                {renderCatalogDetail(catalogResource.description, "Description", {enableLinkParsing: true})}
                {isFimcAdmin() && renderCatalogDetail(catalogResource.keywords, "Keywords")}
                {renderCatalogDetail(catalogResource.relatedItems, "Related Items", {enableLinkParsing: true})}
                {renderCatalogDetail(getLoanDurationTextByValue(catalogResource.loanTerms), "Loan Terms")}
                {
                    canManageCatalog &&
                    <>
                        {renderCatalogDetail(catalogResource.accessoriesAndParts, "Accessories and Parts")}
                        {renderCatalogDetail(catalogResource.vendor, "Vendor")}
                        {renderCatalogDetail(catalogResource.notes, "Notes")}
                        {renderCatalogDetail(catalogResource.isForInternalUse, "Is For Internal Use", {showBooleanOnlyIfTrue: true})}
                    </>
                }

                {
                    canManageCatalog &&
                    <div style={{marginTop: '10px'}}>
                        <ButtonLinkStyle
                            label={"Edit Item"}
                            name={`btnEdit${catalogResource.loanLibraryCatalogId}`}
                            onClick={handleClickEdit}
                        />
                    </div>
                }
            </GridCell>
        </GridContainer>
    );
};

